export var Locale;
(function (Locale) {
    Locale["FR"] = "fr";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));
//# sourceMappingURL=locale.js.map